<template>
  <div :class="[{'row': !noRow}, className]" class="" :style="combinedStyles">
    <template v-for="field in fields" :key="field.id">
      <componentRenderer
        :class="`col-lg-${field.properties.grid.columns}`"
        :field="field"
        v-on:component-updated="updated"
      />
    </template>
  </div>
</template>
<script>
import componentRenderer from "@/components/component-renderer";
import _ from 'lodash';

export default {
  name: "empty-bucket",
  components: { componentRenderer },
  data () {
    return {
      cssString: ""
    }
  },
  computed: {
    combinedStyles () {
      // Create a style string from the style object and append cssString
      let styleStr = '';
      if (this.styles) {
        Object.entries(this.styles).forEach(([key, value]) => {
          styleStr += `${key}:${value};`;
        });
      }
      return styleStr + this.cssString;
    }
  },
  props: {
    fieldId: String,
    requires: Array,
    fields: {
      type: Array,
      required: true
    },
    grid: {
      type: Object
    },
    noRow: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object,
      default: () => {
        return {};
      }
    },
    className: {
      type: String
    }
  },
  methods: {
    updated (field, properties) {
      if (!field || !field.fieldId) {
        return;
      }

      let updatedField = _.find(this.fields, function (fld) {
        return fld.fieldId === field.fieldId;
      });

      if (updatedField) {
        updatedField.properties = { ...updatedField.properties, ...properties };

        if (this.fieldId) {
          this.$store.dispatch("setComponentStatus", {
            component: this.fieldId,
            status: true
          });
        }
      }
    }
  }
};
</script>
<style scoped lang="scss">
.row {
  :deep([disabled="true"]) {
    pointer-events: none;
  }
}
@media (max-width: 1024px) {
  .between-banner-space {
    height: 30px !important;
  }
}
@media (min-width: 992px) {
  .desktop {
    display: block;
  }

  .mobile {
    display: none;
  }
}
@media (max-width: 991px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
}

</style>
